/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {EntryAndExitFormsTableApp} from "../../Functionality/EntryAndExitForms/EntryAndExitFormsTableApp";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import CustomTable from "../../../../../components/table/CustomTable";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import {permissionObj} from "../../../../../Helpers/permission";
import React from "react";
import ChooseAFormModal from "../../Modal/ChooseAFormModal";

const EntryAndExitFormsTable = ({
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSearch,
    setSimpleSearch,
    finalArray,
    modified,
    setModified,
    setCriteria,
    showCreateModal,
    setShowCreateModal
}) => {
    const {
        t,
        handleDeleteAll,
        permission,
        DEV,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        deletePermission,
        getData
    } = EntryAndExitFormsTableApp({
        selectedList,
        setSelectedList,
        setIsAllChecked,
        option,
        setBodyForExport,
        searchElement,
        finalArray,
        modified,
        setModified,
        setCriteria,
    });

    return (
        <>
            <SearchSimple
                id={"txt_mrt_search_simple"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
                // The simple search drops the filters of the advanced search, so the
                // export goes back to the simple endpoint along with the table
                callApi={() => {
                    setSearch(false);
                    getData(0, {searchElement});
                }}
                resetApi={() => {
                    setSearch(false);
                    getData(0, {searchElement: ''});
                }}
            />
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_dont_have_any_entry_&_exit_forms_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_ENTRY_AND_EXIT_FORMS_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_eae_create'} card={true}
                                                   onClick={() => setShowCreateModal(true)}
                                                   name={'create_new_entry_&_exit_form'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}

            { showCreateModal &&
                <ChooseAFormModal
                    show={showCreateModal}
                    onHide={() => setShowCreateModal(false)}
                />
            }
        </>
    );
};

export default EntryAndExitFormsTable;
